import { Injectable } from '@angular/core';
import { AlarisProfileService, RouterDataLink, RouterDataLinks } from '@campaign-portal/components-library';

import { routerLinks } from '../router-links.const';

@Injectable({
	providedIn: 'root',
})
export class MenuService {
	readonly menuList: RouterDataLinks = routerLinks;

	constructor(private readonly profile: AlarisProfileService) {}

	getHomeLink(): RouterDataLink {
		return (
			Object.values(this.menuList).find((route: RouterDataLink) => {
				return (
					this.profile.allowed(route.data.permissions, route.data.permissionComparison ?? 'every') &&
					!route.data.hiddenMenu
				);
			}) ?? this.menuList.accountSettings
		);
	}
}
